import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import brandsData from '../../../assets/master-data/brands';
import devicesData from '../../../assets/master-data/devices';
import { ClickToCallComponent } from '../../modules/click-to-call/click-to-call.component';
import { ClaimConfig } from '../models/claim-config';
import { CodeDescription } from '../models/code-decription';
import { DevicesBrands } from '../models/devices-brands';
import { GetDecisionTreeResult } from '../models/dto/get-decision-tree-response';
import { OpenClaimResponse,MoreInfoI } from '../models/dto/open-claim-response';
import { Language } from '../models/language';
import { Relationship } from '../models/relationship';
import { Subject } from 'rxjs';
import { LlamanosComponent } from '../../modules/llamanos/llamanos.component';
import { GetClientResult } from '../models/dto/get-client-response';
import { SendDocumentsResult } from '../models/dto/send-documents-response';
import { ConfirmAppointmentResult } from '../models/dto/confirm-appointment-response';
import { EntranceTreesResult } from '../models/dto/entrance-trees-response';
import { GetTimesZoneResult } from '../models/dto/get-times-zone-response';
import { ServiceErrorStatus } from '../models/dto/service-error';
import { UrgenciaComponent } from '../../modules/urgencia/urgencia.component';


@Injectable({
	providedIn: 'root'
})
export class MasterDataService {

	c2cButtonShow: boolean = true;
	c2cButtonShowSubject = new Subject<boolean>();
	existNonPayment: boolean = false;
	claimNotConsolidated: boolean = false;
	notAppointmentAvailable: boolean = false;

	/* variable para saber si existe cita o no. Da igual si ha sido elección del cliente o ejecución del sistema*/
	appointment: boolean = false;

	constructor(private translate: TranslateService, private modalService: NgbModal) {}

	getCausedIcons(): { [key: string]: string } {
		return {
			'01': 'icon hs-icon-danos-agua me-4',
			'03': 'icon hs-icon-danos-electricos me-4',
			'06': 'icon hs-icon-responsabilidad-civil me-4',
			'07': 'icon hs-icon-robo me-4',
			'12': 'icon hs-icon-rotura-cristales me-4',
			'13': 'icon hs-icon-incendio me-4',
			'14': 'icon hs-icon-fenomenos-meteorologicos me-4',
			'15': 'icon hs-icon-solicitud-mantenimientos me-4',
			'16': 'icon hs-icon-otros me-4'
			// hs-icon-todo-riesgo
		};
	}

	getDamageTypeIdWithDevices(): string[] {
		return ['842'];
	}

	getDamageDetailIdWithDevices(): string[] {
		return ['3701', '3703', '4097', '4098', '4121'];
	}

	getRelationships(): Promise<Relationship[]> {
		return new Promise((resolve, reject) => {
			this.translate.get('contactDetails.declarantData.relationship.insured').subscribe({
				next: (insured) =>
					resolve([
						{
							description: insured,
							code: '00',
							authorized: true,
							productType: 'HOGAR'
						},
						{
							description: this.translate.instant('contactDetails.declarantData.relationship.family'),
							code: '01',
							authorized: true,
							productType: 'HOGAR'
						},
						{
							description: this.translate.instant('contactDetails.declarantData.relationship.office'),
							code: '03',
							authorized: true,
							productType: 'HOGAR'
						},
						// {
						// 	description: this.translate.instant('contactDetails.declarantData.relationship.tenant'),
						// 	code: '99',
						// 	authorized: false,
						// 	productType: 'HOGAR'
						// },
						{
							description: this.translate.instant('contactDetails.declarantData.relationship.others'),
							code: '99',
							authorized: false,
							productType: 'HOGAR'
						}
					]),
				error: (error) => reject(error)
			});
		});
	}
	
	getCauseInjuredRelationships(): Promise<Relationship[]> {
		return new Promise((resolve, reject) => {
			this.translate.get('contactDetails.declarantData.relationship.insured').subscribe({
				next: (insured) =>
					resolve([
						{
							description: this.translate.instant('claimData.relationship.neighbour'),
							code: '00',
							authorized: true,
							productType: ''
						},
						{
							description: this.translate.instant('claimData.relationship.ownersCommunity'),
							code: '01',
							authorized: true,
							productType: ''
						},
						{
							description: this.translate.instant('claimData.relationship.others'),
							code: '02',
							authorized: false,
							productType: ''
						},
					]),
				error: (error) => reject(error)
			});
		});
	}

	getTypesPhone(): CodeDescription[] {
		return [
			{
				code: '2',
				description: 'Móvil'
			},
			{
				code: '1',
				description: 'Fijo'
			}
		];
	}

	getDevices(language: string): DevicesBrands[] {
		const devices: DevicesBrands[] = [];
		let brands: CodeDescription[];
		let brand: CodeDescription | undefined;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(devicesData as any[]).forEach((device) => {
			brands = [];
			device.brands.forEach((brandCode: string) => {
				brand = brandsData.find((brandData) => brandData.code === brandCode);
				brand ? brands.push(brand) : undefined;
			});

			this.tratarListaBrands(brands,language);

			devices.push({
				code: device.code,
				description: device.description[language],
				brands: brands
			});
		});

		if(devices && devices.length > 0){
			this.tratarListaDevices(devices);
		}

		return devices;
	}

	// Ordena la lista de Devices y si tiene el Device 'Otros' se coloca en ultima posicion
	private tratarListaDevices(devices:DevicesBrands[]) {
		devices.sort( (deviceA,deviceB) => {
			return deviceA.description < deviceB.description ? -1 : deviceA.description > deviceB.description ? 1 : 0;
	   });
	   let deviceAP019:any = devices.find((device) => device.code === 'AP019');
	   devices.splice(
		   devices.findIndex((device) => device.code === 'AP019'),
		   1
	   );
	   devices.push({
		   code: deviceAP019.code,
		   description: deviceAP019.description,
		   brands: deviceAP019.brands
	   });
	}


	// Ordena la lista de Brands y si tiene el Brand 'Otros' se traduce y se coloca en ultima posicion
	private tratarListaBrands(brands:CodeDescription[],language: string) {
		if(brands && brands.length > 0){
			brands.sort( (brandA,brandB) => {
				return brandA.description < brandB.description ? -1 : brandA.description > brandB.description ? 1 : 0;
		   });
		}
		
		let brandMR043:any = brands.find((brand) => brand.code === 'MR043');
			if(brandMR043){
				brands.splice(
					brands.findIndex((brand) => brand.code === 'MR043'),
					1
				);
				let brandDescription = '';
				if(language) {
					if(language.toLowerCase() === 'es'){
						brandDescription = "OTROS";
					}
					if(language.toLowerCase() === 'en'){
						brandDescription = "OTHERS";
					}
					if(language.toLowerCase() === 'ca'){
						brandDescription = "ALTRES";
					}
				}
				brands.push({
					code: brandMR043.code,
					description: brandDescription
				});
			}
	}

	getCausesWithOtherHomeDamages() {
		return ['01', '03', '13'];
	}

	getLanguages(): Language[] {
		return [
			{
				id: '3',
				description: 'Castellano',
				i18nKey: 'es'
			},
			{
				id: '6',
				description: 'Ingles',
				i18nKey: 'en'
			},
			{
				id: '2',
				description: 'Catalan',
				i18nKey: 'ca'
			}
		];
	}

	getTechnicianKeyToSendDevices() {
		return 'Técnico gama blanca/marrón';
	}

	isValidTechnicianKeyToSendDevices(tecnico:any) {
		let retorno:boolean = false;
		if(tecnico && typeof tecnico === 'string'){
			retorno = this.getTechnicianKeyToSendDevices().trim().toUpperCase() === tecnico.trim().toUpperCase();
		}
		return retorno;
	}

	getIndemnizableKeys() {
		return ['Mixto', 'Indemnizable'];
	}

	getUrgencyTechnicians() {
		return ['fontanero', 'electricista', 'cerrajero', 'cristalero'];
	}

	getClaimConfig(): ClaimConfig[] {
		return [
			{
				claimType: '1',
				claimTypeDescription: 'Reparable',
				typeCall: '4',
				typeCallDescription: 'Siniestro'
			},
			{
				claimType: '2',
				claimTypeDescription: 'Mixto',
				typeCall: '4',
				typeCallDescription: 'Siniestro'
			},
			{
				claimType: '3',
				claimTypeDescription: 'Indemnizable',
				typeCall: '4',
				typeCallDescription: 'Siniestro'
			},
			{
				claimType: '4',
				claimTypeDescription: 'Rechazo total',
				typeCall: '2',
				typeCallDescription: 'C2C'
			},
			{
				claimType: '5',
				claimTypeDescription: 'Reparable;Mixto;Indemnizable',
				typeCall: '4',
				typeCallDescription: 'Siniestro'
			},
			{
				claimType: '6',
				claimTypeDescription: 'Apertura Parcial',
				typeCall: '3',
				typeCallDescription: 'Siniestro'
			},
			{
				claimType: '7',
				claimTypeDescription: 'Registro llamada',
				typeCall: '3',
				typeCallDescription: 'Llamame'
			},
			{
				claimType: '8',
				claimTypeDescription: 'Registro llamada',
				typeCall: '3',
				typeCallDescription: 'Llamame'
			},
			{
				claimType: '13',
				claimTypeDescription: 'Manitas',
				typeCall: '4',
				typeCallDescription: 'Siniestro'
			},
			{
				claimType: '14',
				claimTypeDescription: 'Servicio especial rep',
				typeCall: '4',
				typeCallDescription: 'Siniestro'
			},
			{
				claimType: '15',
				claimTypeDescription: 'Servicio especial ind',
				typeCall: '4',
				typeCallDescription: 'Siniestro'
			},
			{
				claimType: '16',
				claimTypeDescription: 'C2C Rechazo total',
				typeCall: '2',
				typeCallDescription: 'C2C'
			},
			{
				claimType: '17',
				claimTypeDescription: 'C2C Apertura parcial',
				typeCall: '2',
				typeCallDescription: 'C2C'
			},
			{
				claimType: '18',
				claimTypeDescription: 'C2C 2',
				typeCall: '2',
				typeCallDescription: 'C2C'
			},
			{
				claimType: '19',
				claimTypeDescription: 'Llámame	3',
				typeCall: '3',
				typeCallDescription: 'Llamame'
			}
		];
	}

	getClaimValidIds() {
		return this.getClaimConfig()
			.filter((claimConfig) => claimConfig.typeCallDescription === 'Siniestro')
			.map((claimConfig) => claimConfig.claimType);
	}

	getClaimTypeDescription (claimType:string) {
		var value = this.getClaimConfig()
		.filter((claimConfig) => claimConfig.claimType === claimType)
		.map((claimConfig) => claimConfig.claimTypeDescription);
		if (value){
			return value.toString();
		} else {
			return "";
		}
	}

	getC2CIds() {
		return this.getClaimConfig()
			.filter((claimConfig) => claimConfig.typeCallDescription === 'C2C')
			.map((claimConfig) => claimConfig.claimType);
	}

	getLlamanosIds() {
		return this.getClaimConfig()
			.filter((claimConfig) => claimConfig.typeCallDescription === 'Llamame')
			.map((claimConfig) => claimConfig.claimType);
	}

	getLlamanosMotive() {
		return '00019_Llámanos';
	}

	manageGetClientControlledErrors(response: GetClientResult){
		switch (response.typeError){
			case '10006':
				this.createClickToCall(`${response.typeError}_Poliza_complementaria`);
				break;
			case '10010':
				this.createClickToCall(`${response.typeError}_Suspensión_de_garantías`);
				break;
			case '20001':
				this.createLlamanos(`${response.typeError}_Seguridad_llamada_no_autorizada`);
				break;
			case '20002':
				this.createLlamanos(`${response.typeError}_Validación_de_campos`);
				break;
			case '40001':
				this.createLlamanos(`${response.typeError}_Cliente_No_localizado`);
				break;
			case '60001':
				this.createClickToCall(`${response.typeError}_PROBLEMA_NO_CONOCIDO`);
				break;
		}
	}

	manageEntrancesTreeControlledErrors(response: EntranceTreesResult){
		switch(response.typeError){
			case '20002':
				this.createLlamanos(`${response.typeError}_Validación_de_campos`);
				break;
			case '20005':
				this.createClickToCall(`${response.typeError}_SONDEO_NO_ACCESIBLE`);
				break;
		}
	}

	manageDecisionTreeControlledErrors(response: GetDecisionTreeResult) {
		if(!response.typeError){
			switch (response.claimType) {
				case '16':
					this.createClickToCall(`000${response.claimType}_C2C_Rechazo_total`, response.rejectionReasonCode);
					break;
				case '17':
					this.createClickToCall(`000${response.claimType}_C2C_Apertura_parcial`, response.rejectionReasonCode);
					break;
				case '18':
					this.createClickToCall(`000${response.claimType}_C2C`, response.rejectionReasonCode);
					break;
				case '19':
					this.createLlamanos(`000${response.claimType}_Llámanos`, response.rejectionReasonCode);
					break;
				case '10007':
					this.createClickToCall('00018_C2C', `${response.rejectionReason} ${response.rejectionReasonCode}`);
					break;
			}
		}
		else {
			switch (response.typeError) {
				case '20002':
					this.createLlamanos(`${response.typeError}_Validación_de_campos`);
					break;
				case '20005':
					this.createClickToCall(`${response.typeError}_SONDEO_NO_ACCESIBLE`);
					break;
			}
		}
		
	}

	manageOpenClaimControlledErrors(response: OpenClaimResponse) {
		switch (response.openClaimResult.typeError) {
			case '10001':
				this.createClickToCall(`${response.openClaimResult.typeError}_duplicados`);
				break;
			case '10002':
				this.createClickToCall(`${response.openClaimResult.typeError}_control_mantenimientos_anualidad`);
				break;
			case '10003':
				this.createClickToCall(`${response.openClaimResult.typeError}_Corrosion`);
				break;
			case '10004':
				this.createClickToCall(`${response.openClaimResult.typeError}_Urgencias`);
				break;
			case '10005':
				this.createClickToCall(`${response.openClaimResult.typeError}_Tercero_causante`);
				break;
			case '10006':
				this.createClickToCall(`${response.openClaimResult.typeError}_Poliza_complementaria`);
				break;
			case '10007':
				this.createClickToCall(`${response.openClaimResult.typeError}_Otro_tipo_averias`);
				break;
			case '10008':
				this.createClickToCall(`${response.openClaimResult.typeError}_Peticion_C2C_Cliente`);
				break;
			case '10009':
				this.createClickToCall(`${response.openClaimResult.typeError}_LIMITE_APERTURAS_SUPERADO`, 'Se ha superado el limite de aperturas de este usuario');
				break;
			case '10011':
				this.createClickToCall(`${response.openClaimResult.typeError}_Control FFMM`, 
				response.openClaimResult 
				&& response.openClaimResult.languageInfo 
				&& response.openClaimResult.languageInfo.length > 0 
				&& response.openClaimResult.languageInfo[0]
				&& response.openClaimResult.languageInfo[0].error 
					? response.openClaimResult.languageInfo[0].error : undefined);
			    break;
			case '20002':
				this.createLlamanos(`${response.openClaimResult.typeError}_Validación_de_campos`);
				break;
			case '50001':
				this.createClickToCall(`${response.openClaimResult.typeError}_PROBLEMA_ATILA_SIN_RESPUESTA`);
				break;
			case '50002':
				this.createClickToCall(`${response.openClaimResult.typeError}_PROBLEMA_ATILA_NO_CONOCIDO`);
				break;
			case '50003':
				this.createClickToCall(`${response.openClaimResult.typeError}_PROBLEMA_ATILA_CONTROLADO`);
				break;
			case '60001':
				this.createClickToCall(`${response.openClaimResult.typeError}_PROBLEMA_NO_CONOCIDO`);
				break;
			case '60002':
				this.createClickToCall(`${response.openClaimResult.typeError}_Problema_dirección_Riesgo`);
				break;
			case '70001':
				if(this.isGroupResolvingCC(response)){
					this.createClickToCall(`${response.openClaimResult.typeError}_PROBLEMA_SCA`);
				}
				this.claimNotConsolidated = true;
				break;
			/* case '003003':
				//this.createClickToCall(`${response.openClaimResult.typeError}_PROBLEMA_DOCUMENTACION`);
				break;
			case '001094':
				//this.createClickToCall(`${response.openClaimResult.typeError}_PROBLEMA_DOCUMENTACION`);
				break; */
		}
	}

	manageGetTimesZoneControlledErrors(response: GetTimesZoneResult){
		let reason = '';
		let reasonDesc = '';
		if(response.reason && response.reason !== ''){
			this.notAppointmentAvailable = true;
			reason = response.reason;
			reasonDesc = response.reasonDescription ?? '';
			// switch (response.reason){
			// 	case '6':
			// 	case '11':
			// 	case '15':
			// 		this.notAppointmentAvailable = true;
			// 		reason = response.reason;
			// 		reasonDesc = response.reasonDescription ?? '';
			// 		break;
			// }	
		}
		if(response.typeError){
			switch (response.reason){
				case '20002':
					this.createLlamanos(`${response.reason}_Validación_de_campos`);
					break;
				case '70001':
					this.claimNotConsolidated = true;
					break;
			}
		}
		return {reason, reasonDesc};
	}

	manageConfirmAppointmentControlledErrors(response: ConfirmAppointmentResult){
		switch (response.typeError){
			case '20002':
				this.createLlamanos(`${response.typeError}_Validación_de_campos`);
				break;
			case '70001':
				// que hacemos si llega este mensaje?
				//this.claimNotConsolidated = true;
				break;
		}
	}

	manageSendDocumentsControlledErrors(response: SendDocumentsResult) {
		this.createClickToCall(response.TypeError ?? '', response.error);
	}

	createClickToCall(typeError: string, reason?: string) {
		const modalRef = this.modalService.open(ClickToCallComponent, {
			centered: true,
			windowClass: 'modal-call',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.motiveC2C = typeError;
		modalRef.componentInstance.submotiveC2C = reason ?? 'Fallo de apertura de siniestro.';
	}

	createLlamanos(typeError: string, reason?: string){
		const modalRef = this.modalService.open(LlamanosComponent, {
			centered: true,
			windowClass: 'modal-help',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.motiveLlamanos = typeError;
		modalRef.componentInstance.submotiveLlamanos = reason ?? 'Fallo de apertura de siniestro.';
		modalRef.componentInstance.submotiveShown = reason ?? '';
	}

	hideC2CButton(){
		this.c2cButtonShow = false;
		this.c2cButtonShowSubject.next(false);
	}

	getPhonePrefixList(): string[] {
		return [
			'+34',
			'+1',
			'+1 (242)',
			'+1 (246)',
			'+1 (264)',
			'+1 (268)',
			'+1 (284)',
			'+1 (340)',
			'+1 (345)',
			'+1 (441)',
			'+1 (473)',
			'+1 (649)',
			'+1 (664)',
			'+1 (670)',
			'+1 (671)',
			'+1 (684)',
			'+1 (758)',
			'+1 (767)',
			'+1 (784)',
			'+1 (787/939)',
			'+1 (809/829)',
			'+1 (868)',
			'+1 (869)',
			'+1 (876)',
			'+20',
			'+212',
			'+213',
			'+216',
			'+218',
			'+220',
			'+221',
			'+222',
			'+223',
			'+224',
			'+225',
			'+226',
			'+227',
			'+228',
			'+229',
			'+230',
			'+231',
			'+232',
			'+233',
			'+234',
			'+235',
			'+236',
			'+237',
			'+238',
			'+239',
			'+240',
			'+241',
			'+242',
			'+243',
			'+244',
			'+245',
			'+246',
			'+247',
			'+248',
			'+249',
			'+250',
			'+251',
			'+252',
			'+253',
			'+254',
			'+255',
			'+256',
			'+257',
			'+258',
			'+260',
			'+261',
			'+262',
			'+263',
			'+264',
			'+265',
			'+266',
			'+267',
			'+268',
			'+269',
			'+269',
			'+27',
			'+290',
			'+290',
			'+291',
			'+297',
			'+298',
			'+299',
			'+30',
			'+31',
			'+32',
			'+33',
			'+350',
			'+351',
			'+352',
			'+353',
			'+354',
			'+355',
			'+356',
			'+357',
			'+358',
			'+359',
			'+36',
			'+370',
			'+371',
			'+372',
			'+373',
			'+374',
			'+375',
			'+376',
			'+377',
			'+378',
			'+379',
			'+380',
			'+381',
			'+382',
			'+385',
			'+386',
			'+387',
			'+388',
			'+389',
			'+39',
			'+39',
			'+40',
			'+41',
			'+420',
			'+421',
			'+423',
			'+43',
			'+44',
			'+45',
			'+46',
			'+47',
			'+48',
			'+49',
			'+500',
			'+501',
			'+502',
			'+503',
			'+504',
			'+505',
			'+506',
			'+507',
			'+508',
			'+509',
			'+51',
			'+52',
			'+53',
			'+54',
			'+55',
			'+56',
			'+57',
			'+58',
			'+590',
			'+591',
			'+592',
			'+593',
			'+594',
			'+595',
			'+596',
			'+597',
			'+598',
			'+599',
			'+60',
			'+61',
			'+62',
			'+63',
			'+64',
			'+65',
			'+66',
			'+670',
			'+672',
			'+673',
			'+674',
			'+675',
			'+676',
			'+677',
			'+678',
			'+679',
			'+680',
			'+681',
			'+682',
			'+683',
			'+685',
			'+686',
			'+687',
			'+688',
			'+689',
			'+690',
			'+691',
			'+692',
			'+7',
			'+7',
			'+800',
			'+808',
			'+81',
			'+82',
			'+84',
			'+850',
			'+852',
			'+853',
			'+855',
			'+856',
			'+86',
			'+870',
			'+878',
			'+880',
			'+881',
			'+882',
			'+883',
			'+886',
			'+888',
			'+90',
			'+91',
			'+92',
			'+93',
			'+94',
			'+95',
			'+960',
			'+961',
			'+962',
			'+963',
			'+964',
			'+965',
			'+966',
			'+967',
			'+968',
			'+970',
			'+971',
			'+972',
			'+973',
			'+974',
			'+975',
			'+976',
			'+977',
			'+979',
			'+98',
			'+991',
			'+992',
			'+993',
			'+994',
			'+995',
			'+996',
			'+998'
		];
	}

	isGroupResolvingCC(response :OpenClaimResponse | ServiceErrorStatus): boolean {
		let retorno : boolean = false;
		if("openClaimResult" in response) {
			if(response && response.openClaimResult && response.openClaimResult.languageInfo && response.openClaimResult.languageInfo.length > 0){
				for(let index = 0 ; index <  response.openClaimResult.languageInfo.length ; index++){
					if(response.openClaimResult.languageInfo[index].moreInfoI && response.openClaimResult.languageInfo[index].moreInfoI.length > 0){
						for(let index2 = 0 ; index2 <  response.openClaimResult.languageInfo[index].moreInfoI.length ; index2++){
							if(response.openClaimResult.languageInfo[index].moreInfoI[index2].resolvingGroup && response.openClaimResult.languageInfo[index].moreInfoI[index2].resolvingGroup.length > 0){
								for(let index3 = 0 ; index3 <  response.openClaimResult.languageInfo[index].moreInfoI[index2].resolvingGroup.length ; index3++){
									let valueResolvingGroup = response.openClaimResult.languageInfo[index].moreInfoI[index2].resolvingGroup[index3];
									if(valueResolvingGroup && valueResolvingGroup.includes('CC')){
										retorno = true;
										return retorno;
									}
								}
							}
						}
					}
				}	
			}
		}
		return retorno;
	}


	showPopUpUrgencia():any{
		return this.modalService.open(UrgenciaComponent, {
			windowClass: 'modal-small',
			centered: true,
			backdrop: 'static',
			keyboard: false
		});
	}
}
